import { render } from "./salary-components.vue?vue&type=template&id=1cbc356a&scoped=true"
import script from "./salary-components.vue?vue&type=script&lang=js"
export * from "./salary-components.vue?vue&type=script&lang=js"

import "./salary-components.vue?vue&type=style&index=0&id=1cbc356a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbc356a"]])

export default __exports__